const actions = {
    AI_SEARCH_MSIC_CODE_REQUEST: 'AI_SEARCH_MSIC_CODE_REQUEST',
    AI_SEARCH_MSIC_CODE_SUCCESS: 'AI_SEARCH_MSIC_CODE_SUCCESS',
    AI_SEARCH_MSIC_CODE_ERROR: 'AI_SEARCH_MSIC_CODE_ERROR',

    AI_SEARCH_CLASSIFICATION_CODE_REQUEST: 'AI_SEARCH_CLASSIFICATION_CODE_REQUEST',
    AI_SEARCH_CLASSIFICATION_CODE_SUCCESS: 'AI_SEARCH_CLASSIFICATION_CODE_SUCCESS',
    AI_SEARCH_CLASSIFICATION_CODE_ERROR: 'AI_SEARCH_CLASSIFICATION_CODE_ERROR',

    searchMsicCode: description => ({
        type: actions.AI_SEARCH_MSIC_CODE_REQUEST,
        description,
    }),

    searchClassificationCode: name => ({
        type: actions.AI_SEARCH_CLASSIFICATION_CODE_REQUEST,
        name,
    }),
};

export default actions;
